import React from 'react';
import { CompaniesList } from '../../components/admin/CompaniesList';
import { useCompaniesList } from '../../hooks/useCompaniesList';

export const CompaniesListPage: React.FC = () => {
  const companiesListProps = useCompaniesList();

  return <CompaniesList {...companiesListProps} />;
};
